var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FlatpageLegalBase", [
    _c("h1", [_vm._v("Brilliant Privacy Notice For California Residents")]),
    _vm._v(" "),
    _c("h2", [_vm._v("Last Updated January 1, 2020")]),
    _vm._v(" "),
    _c(
      "p",
      [
        _vm._v(
          '\n    Brilliant Worldwide, Inc. has prepared this California Privacy Notice (the\n    "'
        ),
        _c("strong", [_vm._v("Notice")]),
        _vm._v(
          '") to inform California residents of (1) the information that relates\n    to or could reasonably be associated with California residents or households ("'
        ),
        _c("strong", [_vm._v("Personal Information")]),
        _vm._v(
          '") that we collect and how we use and disclose that information and (2) the privacy rights\n    California residents may have relating to their Personal Information and how those rights can\n    be exercised. This Notice is incorporated into and forms part of our\n    '
        ),
        _c(
          "router-link",
          { attrs: { to: { name: "flatpage_privacypolicy" } } },
          [_vm._v("Privacy Policy")]
        ),
        _vm._v(
          ". By\n    accessing or using the Service, you agree to the practices described in this Notice. If you do\n    not agree to this Notice, please do not access the Site or otherwise use the Service. All\n    capitalized but undefined terms shall have the meanings assigned to them in the\n    "
        ),
        _c(
          "router-link",
          { attrs: { to: { name: "flatpage_privacypolicy" } } },
          [_vm._v("Privacy Policy")]
        ),
        _vm._v(".\n  ")
      ],
      1
    ),
    _vm._v(" "),
    _c("h3", [
      _vm._v("1. Personal Information Collection, Use, and Disclosure")
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    The following table describes (1) the categories of Personal Information we collect, (2)\n    examples of the types of information that fall within each category of Personal Information\n    collected, (3) how we use each category of Personal Information, and (4) how we disclose\n    Personal Information.\n  "
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "table-wrapper" }, [
      _c("table", { staticClass: "table" }, [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("Category of Personal Information")]),
            _vm._v(" "),
            _c("th", [_vm._v("Examples")]),
            _vm._v(" "),
            _c("th", [_vm._v("Sources Of Personal Information")]),
            _vm._v(" "),
            _c("th", [_vm._v("Use of Personal Information")]),
            _vm._v(" "),
            _c("th", [_vm._v("Disclosure of Personal Information")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("Identification Information")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            Your first and last name, address (optional), birthday, IP address, email address, and\n            payment information (optional - only for subscribers)\n          "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v("We obtain Identification Information from you.")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            We use Identification Information for anti-fraud measures, debugging, creating\n            accounts, and creating optional community profiles.\n          "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            We disclose Identification Information to analytics services, marketing platforms,\n            email providers, and payment processors.\n          "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Social Media Information")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            If you sign up for the Service using a social media account, we may collect\n            information from the social media service. The information we collect will depend on\n            your settings with the social media service but could include your name, email,\n            preferred language, profile photo, and other information.\n          "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            We collect Social Media Information from the social media service that you use to\n            log-in to the Services.\n          "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            We use Social Media Information to conduct business analytics and to create accounts\n            on our platform.\n          "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "We disclose Social Media Information to analytics services and email providers."
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Internet Activity Information")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            We may collect information relating to how you use our websites and apps (such as your\n            IP address, domain server, and browser type), whether you open or click links in\n            emails we send, and how you interact with our advertisements.\n          "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            We obtain Internet Activity Information from you and third-party marketing platforms.\n          "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            We use Internet Activity Information for anti-fraud measures, debugging, and\n            conducting analytics.\n          "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            We disclose Internet Activity Information to analytics services and marketing\n            platforms.\n          "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Location Information")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "We may derive a rough estimate of your location from your IP address."
              )
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("We obtain Location Information from you.")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            We use Location Information for anti-fraud measures, debugging, and conducting\n            analytics.\n          "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            We disclose Location Information to analytics services, marketing platforms, and email\n            providers.\n          "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Education Information")]),
            _vm._v(" "),
            _c("td", [_vm._v("Your alma mater (optional).")]),
            _vm._v(" "),
            _c("td", [_vm._v("We obtain Education Information from you.")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "We use Education Information for creating accounts on our platform."
              )
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("We do not disclose your Education Information.")])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v("2. California Privacy Rights")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    To the extent provided for by law and subject to applicable exceptions, California residents\n    have the following privacy rights in relation to the Personal Information we collect:\n  "
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _vm._v(
          "\n      The right to know what Personal Information we have collected and how we have used and\n      disclosed that Personal Information;\n    "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("The right to request deletion of your Personal Information;")
      ]),
      _vm._v(" "),
      _c(
        "li",
        [
          _vm._v(
            "\n      The right to opt out: We do not and will not sell your Personal Information but we may share\n      Personal Information (including Identification Information and Internet Activity\n      Information) with social media platforms and other advertising partners that will use that\n      information to serve you targeted advertisements when you are on social media platforms and\n      other third-party websites. We do not control and are not responsible for the social media\n      platforms' or advertising partners' processing of your Personal Information. You can opt out\n      of all targeted advertising related to our Services by\n      "
          ),
          _c(
            "router-link",
            {
              attrs: {
                to: {
                  name: "flatpage_cookiepolicy",
                  hash: "#types-of-cookies"
                }
              }
            },
            [_vm._v("clicking here")]
          ),
          _vm._v(
            "\n      and you can opt out through our advertising partners individually as follows:\n      "
          ),
          _c("ul", [
            _c("li", [
              _vm._v("\n          Facebook\n          "),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen",
                    target: "_blank"
                  }
                },
                [_vm._v("opt out")]
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("\n          Google\n          "),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://support.google.com/ads/answer/2662922?hl=en-GB",
                    target: "_blank"
                  }
                },
                [_vm._v("opt out")]
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n          Network Advertising Initiative member\n          "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "http://optout.networkadvertising.org/?c=1#!%2F",
                    target: "_blank"
                  }
                },
                [_vm._v("opt out")]
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "\n      The right to be free from discrimination relating to the exercise of any of your privacy\n      rights.\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c("p", [
      _c("strong", [_vm._v("Exercising Your Rights")]),
      _vm._v(
        ": California residents can exercise the above privacy\n    rights by emailing us at: "
      ),
      _c("a", { attrs: { href: "mailto:privacy@brilliant.org" } }, [
        _vm._v("privacy@brilliant.org")
      ]),
      _vm._v(".\n  ")
    ]),
    _vm._v(" "),
    _c("p", [
      _c("strong", [_vm._v("Verification")]),
      _vm._v(
        ": in order to protect your Personal Information from unauthorized\n    access or deletion, we may require you to verify your login credentials before you can submit\n    a request to know or delete Personal Information. If you do not have an account with us, or if\n    we suspect fraudulent or malicious activity, we may ask you to provide additional Personal\n    Information for verification. If we cannot verify your identity, we will not provide or delete\n    your Personal Information.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _c("strong", [_vm._v("Authorized Agents")]),
      _vm._v(
        ": you may submit a request to know or a request to delete\n    your Personal Information through an authorized agent. If you do so, the agent must present\n    signed written permission to act on your behalf and you may also be required to independently\n    verify your identity with us.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v("3. Contact Us")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    If you have questions about this Notice, or need to access this Notice in a different format,\n    please contact us at:\n    "
      ),
      _c("a", { attrs: { href: "mailto:privacy@brilliant.org" } }, [
        _vm._v("privacy@brilliant.org")
      ]),
      _vm._v(".\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }